const commercialBonus = {
  tab: {
    main: "Commission",
    validation: "Validation",
  },
};

export default commercialBonus;
